import { Component, OnInit } from '@angular/core';
import { Utilservice } from '@core/services/util.service';
import { VisitasService } from '@modules/visitas/services/visitas.service';
import { faAirFreshener } from '@fortawesome/free-solid-svg-icons';
import * as toastr from "toastr";

@Component({
  selector: 'app-historico-reagendamento',
  templateUrl: './historico-reagendamento.component.html',
  styleUrls: ['./historico-reagendamento.component.css']
})
export class HistoricoReagendamentoComponent implements OnInit {

  faAirFreshener = faAirFreshener;
  
  lsReagendamentos = [];
  idsChecks: any[] = [];

  fzsInformado = "";
  data1 = "";
  data2 = "";

  isRequestingGrid: boolean = false;

  constructor(private visitService: VisitasService) { }

  ngOnInit() {

  }

  formatDate(date){
    return Utilservice.formatDate(date);
  }

  consultar(){

    if(this.fzsInformado == ""){
      toastr.error('Informe o FZS!');
      return;
    }

    if(this.data1 == ""){
      toastr.error('Informe o inicio do período!');
      return;
    }
    
    if(this.data2 == ""){
      toastr.error('Informe o fim do período!');
      return;
    }

    const params: any = {
      inicioPeriodo: this.data1,
      fimPeriodo: this.data2,
      vendedorSetor: this.fzsInformado,
      dataAgendamento: " ",
      cnpj: " ",
      razaoSocial: " ",
      statusVisita: " "
    }

    this.isRequestingGrid = true;

    this.visitService.listHistoricoReagendamento(params).subscribe(
      data => {
        this.lsReagendamentos = data;
      },
      error => console.log(error),
      () => this.isRequestingGrid = false
    );
  }
}
